import React, { FC } from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Box,
    TextField,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@mui/material';
import { Refresh } from '@mui/icons-material';

export interface FilterValues {
    deliveryDestination: string;
    address: string;
    workResult: string;
    responsiblePerson: string;
    workerName: string;
    status: string;
    startDate: string;
    endDate: string;
}

interface ReportFilterDialogProps {
    open: boolean;
    onClose: () => void;
    onApply: () => void;
    onClear: () => void;
    filterValues: FilterValues;
    setFilterValues: React.Dispatch<React.SetStateAction<FilterValues>>;
    loading?: boolean;
}

const ReportFilterDialog: FC<ReportFilterDialogProps> = ({
    open,
    onClose,
    onApply,
    onClear,
    filterValues,
    setFilterValues,
    loading = false,
}) => {
    // 作業結果の選択肢
    const workResultOptions = [
        { value: "", label: "すべて" },
        { value: "完了", label: "完了" },
        { value: "継続", label: "継続" },
    ];

    // ステータスの選択肢
    const statusOptions = [
        { value: "", label: "すべて" },
        { value: "対応済み", label: "対応済み" },
        { value: "未対応", label: "未対応" },
    ];

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    詳細絞り込み
                    <Button
                        startIcon={<Refresh />}
                        onClick={onClear}
                        size="small"
                        variant="outlined"
                    >
                        クリア
                    </Button>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box py={2}>
                    <Grid container spacing={3}>
                        {/* 1行目 - 納入先、開始日 */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="納入先"
                                value={filterValues.deliveryDestination}
                                onChange={(e) =>
                                    setFilterValues((prev) => ({
                                        ...prev,
                                        deliveryDestination: e.target.value,
                                    }))
                                }
                                fullWidth
                                placeholder="納入先名を入力"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="作業開始日（以降）"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                value={filterValues.startDate}
                                onChange={(e) =>
                                    setFilterValues((prev) => ({
                                        ...prev,
                                        startDate: e.target.value,
                                    }))
                                }
                                fullWidth
                            />
                        </Grid>

                        {/* 2行目 - 作業結果、責任者 */}
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel>作業結果</InputLabel>
                                <Select
                                    value={filterValues.workResult}
                                    label="作業結果"
                                    onChange={(e) =>
                                        setFilterValues((prev) => ({
                                            ...prev,
                                            workResult: e.target.value,
                                        }))
                                    }
                                >
                                    {workResultOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="責任者"
                                value={filterValues.responsiblePerson}
                                onChange={(e) =>
                                    setFilterValues((prev) => ({
                                        ...prev,
                                        responsiblePerson: e.target.value,
                                    }))
                                }
                                fullWidth
                                placeholder="責任者名を入力"
                            />
                        </Grid>

                        {/* 3行目 - 作業者名、ステータス */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="作業者名"
                                value={filterValues.workerName}
                                onChange={(e) =>
                                    setFilterValues((prev) => ({
                                        ...prev,
                                        workerName: e.target.value,
                                    }))
                                }
                                fullWidth
                                placeholder="作業者名を入力"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel>ステータス</InputLabel>
                                <Select
                                    value={filterValues.status}
                                    label="ステータス"
                                    onChange={(e) =>
                                        setFilterValues((prev) => ({
                                            ...prev,
                                            status: e.target.value,
                                        }))
                                    }
                                >
                                    {statusOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    キャンセル
                </Button>
                <Button
                    variant="contained"
                    onClick={onApply}
                    disabled={loading}
                >
                    {loading ? "検索中..." : "適用"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ReportFilterDialog;